import {SIGNS, SIGN_CODES, type SignCode} from '../../lib/sign-catalog'

export interface SignSidebarProps {
    readonly activeCode: SignCode | null
    readonly onSelect: (code: SignCode) => void
}

export function SignSidebar({activeCode, onSelect}: SignSidebarProps) {
    return (
        <aside className='w-56 shrink-0 bg-surface-container-low'>
            <p className='font-mono text-[10px] tracking-[0.25em] uppercase text-foreground/40 px-4 pt-6 pb-3'>
                Zīmes
            </p>
            <nav className='flex flex-col'>
                {SIGN_CODES.map(code => {
                    const def = SIGNS[code]
                    const active = code === activeCode
                    return (
                        <button
                            key={code}
                            type='button'
                            onClick={() => onSelect(code)}
                            className={
                                'text-left px-4 py-3 font-mono text-xs tracking-[0.15em] uppercase transition-colors '
                                + (active ?
                                    'bg-surface-container-high text-foreground'
                                :   'text-foreground/70 hover:text-foreground hover:bg-surface-container-high')
                            }
                        >
                            {def.label}
                        </button>
                    )
                })}
            </nav>
        </aside>
    )
}
